import React from 'react';

/**
 * Static SVG stand-in for the "Key Details List" (LeftRightList) block, shown on
 * its palette card in the v2 editor: a section heading above a card holding a
 * title and a set of label / value rows. Wireframe style, matching
 * {@link ImageCardPreviewGraphic}; scales with its container via the viewBox.
 */

const CARD_X = 30;
const CARD_Y = 64;
const CARD_W = 1120;
const PAD = 28;
const ROW_H = 62;
const ROWS = 6;
const ROWS_TOP = CARD_Y + 100;
const CARD_H = ROWS_TOP - CARD_Y + ROWS * ROW_H + PAD;
const INNER_LEFT = CARD_X + PAD;
const LINE_LEFT = CARD_X + 20;
const LINE_RIGHT = CARD_X + CARD_W - 20;
const COLUMN_X = CARD_X + 360;
const VALUE_WIDTHS = [650, 560, 690, 600, 640, 520];

function Row({ index }: { index: number }) {
  const top = ROWS_TOP + index * ROW_H;
  return (
    <g>
      <rect x={INNER_LEFT} y={top + 16} width="190" height="30" rx="15" fill="#B9C0C6" />
      <rect
        x={COLUMN_X + 40}
        y={top + 16}
        width={VALUE_WIDTHS[index]}
        height="30"
        rx="15"
        fill="#C7CBD0"
      />
      {index < ROWS - 1 && (
        <line
          x1={LINE_LEFT}
          y1={top + ROW_H}
          x2={LINE_RIGHT}
          y2={top + ROW_H}
          stroke="#E7E8E4"
          strokeWidth="1.5"
        />
      )}
    </g>
  );
}

export default function LeftRightListPreviewGraphic() {
  return (
    <svg
      viewBox={`0 0 1180 ${CARD_Y + CARD_H + 20}`}
      width="100%"
      role="img"
      aria-label="Key Details List block: a heading above a card of label and value rows"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <text
        x={CARD_X}
        y="34"
        fontFamily="Manrope, system-ui, -apple-system, sans-serif"
        fontSize="30"
        fontWeight="700"
        fill="#20423A"
      >
        Section heading
      </text>
      <rect
        x={CARD_X}
        y={CARD_Y}
        width={CARD_W}
        height={CARD_H}
        rx="20"
        fill="#F1F2EF"
        stroke="#E4E4E0"
      />
      <rect x={INNER_LEFT} y={CARD_Y + PAD} width="300" height="34" rx="17" fill="#BEC6CC" />
      <line
        x1={LINE_LEFT}
        y1={CARD_Y + 84}
        x2={LINE_RIGHT}
        y2={CARD_Y + 84}
        stroke="#D8DBDE"
        strokeWidth="2"
      />
      <line
        x1={COLUMN_X}
        y1={ROWS_TOP}
        x2={COLUMN_X}
        y2={ROWS_TOP + ROWS * ROW_H}
        stroke="#E7E8E4"
        strokeWidth="1.5"
      />
      {Array.from({ length: ROWS }).map((_, index) => (
        <Row key={index} index={index} />
      ))}
    </svg>
  );
}
